//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import maxBy from 'lodash/maxBy'
import isEmpty from 'lodash/isEmpty'
import roxConfig from '@/scripts/rox-panel-configuration/rox-config.js'

import { mapState, createNamespacedHelpers, mapActions, mapGetters } from 'vuex'
import {
  ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT,
  ACTION_TOGGLE_ROX_PANEL,
  ACTION_PDP_PRESCRIPTION_LENS_CATENTRY_UPDATE,
  ACTION_PDP_PRESCRIPTION_FRAME_CATENTRY_UPDATE,
  ACTION_REMOVE_BENEFITS,
  ACTION_UPDATE_BENEFITS,
  ACTION_UPDATE_EYEMED_STATE,
  ACTION_SET_RXC_SCRIPTS_STATUS,
  ACTION_STORE_RXC_LENS,
} from '@/scripts/store/actions/pdp'
import {
  ACTION_ADD_OPTICS_TO_BAG,
  ACTION_ADD_TO_BAG,
  ACTION_OPEN_EYEMED_MODAL_OR_PANEL,
  ACTION_REMOVE_FROM_CART,
  ACTION_UPDATE_ROX_PANEL_OVERLAY,
} from '@/scripts/store/actions'
import axios from 'axios'
import wcs from '@/scripts/libs/wcs'
import { Cookies } from '@/scripts/libs/cookies'
import Images from '@/scripts/libs/images'
import { RAY_BAN } from '@/scripts/constants/store'
import makeDebug from 'debug'

import {
  SUNGLASSES,
  EYEGLASSES,
  SUN,
  LOW_BRIDGE_FIT,
  HIGH_BRIDGE_FIT,
  OPTICAL,
  ELECTRONICS,
} from '@/scripts/constants/pdp'
import { isProductStellaByProductType } from '@/scripts/libs/products'

import { EYEMED_LOGIN } from '@/scripts/constants/eyemed'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ProductTypeE } from '@/scripts/constants/rox-panel'
import { AFTERPAY, KLARNA } from '@/scripts/constants/pay-over-time'
import { TRUE_LOWERCASE, Y } from '@/scripts/constants/booleans'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import WcsEyemed from '@/scripts/libs/wcs/eyemed'
import { RoxLensPanel } from '@/scripts/libs/rox-lens-panel/RoxLensPanel'
import { ACTION_UPDATE_BACKGROUND } from '@/scripts/store/header/actions'
import Prescription from '@/scripts/libs/prescription'
// TODO: Import this dynamically
import RbRoxMeasurePupillaryDistance from '@/elements/rox-panel/learn-more/rb-rox-measure-pupillary-distance.vue'
// TODO: Import this dynamically
import RbRoxUnderstandYourPrescription from '@/elements/rox-panel/learn-more/rb-rox-understand-your-prescription'
import {
  D_LensPanel_HowToReadPrescription,
  M_LensPanel_HowToReadPrescription,
  D_LensPanel_PupillaryDistance,
  M_LensPanel_PupillaryDistance,
  Eyewear_Protection_Plan,
} from '@/elements/rox-panel/constants/lens-panel-content-names'
import { FrameAdvisor } from '@/scripts/libs/frame-advisor'
import Resources from '@/scripts/libs/resources'
import VirtualMirror from '@/scripts/libs/virtual-mirror/VirtualMirror'
import RbRoxProtectionPlan from '@/elements/rox-panel/learn-more/protection-plan/protection-plan.vue'
import { PDP_CAT_ENTRY_PARAM } from '@/scripts/constants/pdp'
import { RxcConfig } from '@/scripts/libs/rox-lens-panel/RxcConfigModule'
import PDP from '@/scripts/libs/pdp'
import RbRoxPanelSkeleton from '@/elements/rox-panel/rb-rox-panel-skeleton.vue'

const { roxLensPanel, payOverTime, sendItLaterPrescriptionIsEnabled } = wcs.getStoreConfig()
const { mapGetters: mapGettersPdp, mapActions: mapActionsPdp } = createNamespacedHelpers('pdp')
const { mapActions: mapActionsHeader } = createNamespacedHelpers('header')

const debug = makeDebug('rox-lens-panel')

const { locale } = wcs.getStoreConfig()
export default {
  name: 'rb-rox-panel',
  components: {
    RbRoxMeasurePupillaryDistance,
    RbRoxUnderstandYourPrescription,
    RbRoxProtectionPlan,
    RbRoxPanelSkeleton,
  },

  data: () => {
    return {
      isLensesCallDone: false,
      offerPrice: undefined,
      listPrice: undefined,
      isEyeMedEnabled: false,
      sanitizedLocale: WcsLocales.getSanitizedLocale(locale),
      lensesPackages: {},
      isRoxLoaded: false,
      isOverlayVisible: false,
    }
  },

  computed: {
    ...mapState('pdp', ['isRoxPanelRendered']),
    ...mapGetters([
      'newsletterSubmitCounter',
      'orderId',
      'cartItems',
      'translation',
      'roxPanelOverlay',
      'roxPanelOverlayType',
    ]),
    ...mapGettersPdp([
      'correlatedProducts',
      'selectedProduct',
      'selectedRoxOpticLens',
      'isEyeMedApplied',
      'carousel',
      'areRxcScriptsLoaded',
      'rxcLenses',
    ]),
    isProductStella() {
      return isProductStellaByProductType(this.selectedProduct.type)
    },
    productSize() {
      const { isSizeMVPEnabled } = wcs.getStoreConfig()

      return isSizeMVPEnabled
        ? this.selectedProduct.sizes?.find(
            (size) => size.catEntryId === this.selectedProduct.catEntryId
          )?.size ?? ''
        : this.selectedProduct.sizes?.find(
            (size) => size.catEntryId === this.selectedProduct.catEntryId
          )?.label ?? ''
    },
  },
  watch: {
    async isRoxPanelRendered(newVal, oldVal) {
      debug('Trying to render panel')
      if (FrameAdvisor.isInFrameAdvisorPage()) {
        return
      }

      if (newVal && newVal !== oldVal) {
        debug('Inside if in watch property')
        this.updateHeaderBackground(true)
        await this.getLensesAndFrames(this.selectedProduct.roxFrameCatEntryId)
        await this.changeConfigData()
        this.showPrescriptionLensModal()
        if (this.isRoxLoaded) {
          this.renderRXCPanel()
        }
      }
    },
    async newsletterSubmitCounter() {
      await this.getLensesAndFrames(this.selectedProduct.roxFrameCatEntryId)
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.showRoxPanel = async (config) => {
      this.updateHeaderBackground(true)
      await this.getLensesAndFrames(config.frame.roxFrameCatentryId)
      await this.showPrescriptionLensModal(config)
      this.isLensesCallDone = true
      if (this.isRoxLoaded) {
        this.renderRXCPanel()
      }
    }

    window.externalInvocationMethodMapping.openRoxPanel = () => {
      this.$store.dispatch('pdp/' + ACTION_TOGGLE_ROX_PANEL, true)
    }

    window.externalInvocationMethodMapping.configureAndOpenRXCPanel = async (catEntryId) => {
      const productUrl = window.wcs_endpoints.pdp.replace(PDP_CAT_ENTRY_PARAM, catEntryId)
      let productData
      try {
        const payload = await axios.get(productUrl)
        productData = payload.data
      } catch (e) {
        // eslint-disable-next-line
        console.log('Error fetching from Ray-Ban.com')
        // eslint-disable-next-line
        console.error(`> ${e.message} for ${productUrl}`)
        return {}
      }

      this.updateRoxPanelOverlay({
        roxPanelOverlay: true,
        roxPanelOverlayType: productData.product.type,
      })

      this.isOverlayVisible = this.roxPanelOverlay
      const configObject = RxcConfig.mapRxcConfig(productData.product)
      configObject.bridgeAndNosepads = {
        description: productData.product.geoFit[0].label,
        tooltip: this.getBridgeDescription(productData.product),
      }

      configObject.klarnaInstallments = payOverTime.klarna.installments

      this.updateHeaderBackground(true)
      roxConfig.flowName = this.getFlowName(productData.product)
      await this.getLensesAndFrames(configObject.frame.roxFrameCatentryId)

      const selectedSize = productData.product.sizes.find(
        (item) => item.catEntryId === productData.product.catEntryId
      )?.size

      if (productData.product.isSupernova) {
        const carouselData = await PDP.fetchCarousel(productData.product)

        const catEntryIdsToSend = carouselData
          .map((item) => item.variants.find((variant) => variant.size === selectedSize)?.catEntryId)
          .filter((item) => item)

        const allPromises = catEntryIdsToSend.map((catEntryId) => {
          const promise = new Promise((resolve, reject) => {
            this.fetchAndAddCorrelatedProduct(catEntryId).then(resolve).catch(reject)
          })

          return promise
        })

        await Promise.all(allPromises)

        const framesInformations = carouselData
          ?.filter((item) => item.variants.find((variant) => variant.size === selectedSize))
          .map((item) => {
            const catEntryId = item.variants.find(
              (variant) => variant.size === selectedSize
            )?.catEntryId

            const correlatedProduct = get(this.correlatedProducts, catEntryId)

            const frame = {
              brand: RAY_BAN,
              catEntryId: correlatedProduct.catEntryId,
              category: item.hasColoredLenses ? SUNGLASSES : EYEGLASSES,
              color: correlatedProduct.productFrameColor,
              imageUrl: this.getProductImage(correlatedProduct.imageUrl),
              listPrice: this.listPrice,
              offerPrice: this.offerPrice,
              model: correlatedProduct.productFrameModel,
              name: correlatedProduct.modelName,
              roxFrameCatentryId: correlatedProduct.roxFrameCatEntryId,
              rxValues: correlatedProduct.prescriptionThresholds,
              size: this.getCorrelatedProductSize(
                correlatedProduct.catEntryId,
                correlatedProduct.sizes
              ),
              upc: correlatedProduct.partNumber,
              bridgeAndNosepads: {
                description: productData.product.geoFit[0].label,
                tooltip: this.getBridgeDescription(correlatedProduct),
              },
            }

            return frame
          })

        roxConfig.data.frames = [...framesInformations]
      }

      await this.showPrescriptionLensModal(configObject)
      this.isLensesCallDone = true
      if (this.isRoxLoaded) {
        this.renderRXCPanel()
      }
    }

    roxConfig.actionsModule.getPrices = async (frame) => {
      const { catEntryId } = frame
      debug('getPrices is called')
      const data = await this.fetchLensesAndFrames(catEntryId)
      return data.prices
    }

    roxConfig.actionsModule.genericExit = () => {
      this.updateHeaderBackground(false)
      this.$store.dispatch('pdp/' + ACTION_TOGGLE_ROX_PANEL, {
        isRoxPanelRendered: false,
        roxPanelOverlay: false,
        roxPanelOverlayType: '',
      })
    }

    roxConfig.actionsModule.genericSaveLensSelection = (_frameObject, _lensObject) => {
      this.$store.dispatch('pdp/' + ACTION_PDP_PRESCRIPTION_LENS_CATENTRY_UPDATE, _lensObject)
      this.$store.dispatch('pdp/' + ACTION_PDP_PRESCRIPTION_FRAME_CATENTRY_UPDATE, _frameObject)
    }

    roxConfig.actionsModule.genericAddToCart = this.addToCart

    roxConfig.actionsModule.loadLearnMoreContent = (contentName) => {
      return new Promise((resolve) => {
        let html = ''
        switch (contentName) {
          case Eyewear_Protection_Plan:
            html = this.$refs.protectionPanelAndModal?.$el?.innerHTML || ''
            break
          case M_LensPanel_HowToReadPrescription:
          case D_LensPanel_HowToReadPrescription:
            html = this.$refs.understandYourPrescriptionContent.$el.innerHTML
            break
          case D_LensPanel_PupillaryDistance:
          case M_LensPanel_PupillaryDistance:
            html = this.$refs.measurePupillaryDistance.$el.innerHTML
            break
        }
        resolve(html)
      })
    }

    roxConfig.actionsModule.genericSaveEditFromCart = async (
      frameObject,
      lensObject,
      warrantyObject,
      cartMode
    ) => {
      await this.$store.dispatch(ACTION_REMOVE_FROM_CART, cartMode.orderItemId)
      this.addToCart(frameObject, lensObject, warrantyObject, true)
    }
    if (this.sanitizedLocale) {
      roxConfig.translation = {
        language: this.sanitizedLocale.replace('-', '_'),
      }
    }

    this.isEyeMedEnabled = roxLensPanel.isEyemedEnabled
    if (this.isEyeMedEnabled) {
      this.handleEyemedActions()
    } else {
      roxConfig.insuranceModule = undefined
    }

    roxConfig.flowName = this.getFlowName(this.selectedProduct)

    window.addEventListener('RXC_LOADED', this.handleRXCLoaded)
  },

  beforeDestroy() {
    window.removeEventListener('RXC_LOADED', this.handleRXCLoaded)
  },

  methods: {
    ...mapActions({
      openEyemed: ACTION_OPEN_EYEMED_MODAL_OR_PANEL,
      updateRoxPanelOverlay: ACTION_UPDATE_ROX_PANEL_OVERLAY,
    }),
    ...mapActionsPdp({
      fetchAndAddCorrelatedProduct: ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT,
      updateEyemedState: ACTION_UPDATE_EYEMED_STATE,
      removeBenefits: ACTION_REMOVE_BENEFITS,
      updateBenefits: ACTION_UPDATE_BENEFITS,
      storeRxcLens: ACTION_STORE_RXC_LENS,
    }),
    ...mapGetters(['lastAddToBagItem']),
    ...mapActionsHeader({
      updateHeaderBackground: ACTION_UPDATE_BACKGROUND,
    }),
    async addToCart(frameObject, lensObject, _warrantyObject, isCartPage, imagery) {
      const mandatoryServices = lensObject?.lensPackage?.mandatoryServicesList
      if (mandatoryServices) {
        const selectedProduct = {
          roxFrameCatEntryId: frameObject.roxFrameCatentryId,
        }
        const selectedRoxOpticLens = {
          catEntryId: lensObject.lensPackage.catEntryId,
          mandatoryServicesList: mandatoryServices,
        }
        const roxProductImage = imagery?.productImage
        const roxFallbackImage = imagery?.fallbackImage

        await this.$store.dispatch(ACTION_ADD_OPTICS_TO_BAG, {
          selectedProduct,
          selectedRoxOpticLens,
          isPickUpStore: false,
          isMobile: false,
          roxProductImage,
          roxFallbackImage,
          eyewearProtectionId: _warrantyObject?.id ?? '',
        })
      } else {
        const eyewearProtectionParameter = {
          catEntryId_2: _warrantyObject?.id,
          quantity_2: 1,
          eppSet_1: `${frameObject?.catEntryId}_${_warrantyObject?.id}`,
        }

        await this.$store.dispatch(ACTION_ADD_TO_BAG, {
          catEntry: frameObject.catEntryId,
          upcLensRox: lensObject,
          parameters: _warrantyObject ? eyewearProtectionParameter : undefined,
          bypassAnalytics: true,
        })
      }
      const catEntryId = this.selectedProduct.roxFrameCatEntryId || frameObject.roxFrameCatentryId
      const currentProduct = this.cartItems.find(
        (item) => item.catentryId === catEntryId && item.type !== ProductTypeE.STD
      )

      const orderItemId = currentProduct?.orderItemId

      const isPrescriptionInputEnabled = roxLensPanel.isPrescriptionModuleEnabled

      if (isPrescriptionInputEnabled) {
        const prescriptionObject = Prescription.getPrescriptionInStorage()
        if (prescriptionObject) {
          await Prescription.savePrescription(prescriptionObject, +this.orderId, +orderItemId)
        } else if (isCartPage === true) {
          await Prescription.clearPrescription(+this.orderId, +orderItemId)
        }
      }

      if (isCartPage === true && WcsEyemed.isUserLoggedIn()) {
        const postParams = {
          pageTypeIns: 'CartPage',
          isBenefitPricingRequired: true,
          isCalculateViewRequired: true,
        }
        await WcsEyemed.makeBenefitPricingCall(postParams)
        window.location.reload()
      }
      window.location.href = wcs.getEndPoint('shopCartView')
    },

    async showPrescriptionLensModal(config = {}) {
      delete roxConfig.data.lens.catEntryId
      if (this.selectedRoxOpticLens || config.lensCatEntryId) {
        roxConfig.data.lens.catEntryId =
          this.selectedRoxOpticLens?.catEntryId ||
          config.lensCatEntryId ||
          config.frame.roxFrameCatentryId
      }
      roxConfig.currencyFormat = {
        thousandSeparator: roxLensPanel.thousandSeparator,
        decimalSeparator: roxLensPanel.decimalSeparator,
        prefix: this.selectedProduct.prices?.currencySymbol || config?.frame?.currency,
      }

      if (!isEmpty(config.cartMode)) {
        roxConfig.cartMode = config.cartMode
      }

      if (!isEmpty(config)) {
        config.frame.brand = RAY_BAN
        config.frame.listPrice = this.listPrice
        config.frame.offerPrice = this.offerPrice
        roxConfig.data.frame = config.frame
        roxConfig.data.lens.colorCategory = config?.lens?.colorCategory
        roxConfig.data.lens.clen = config?.lens?.clen
        roxConfig.paymentInstallment = this.mapPaymentInstallments(
          config?.klarnaEnabled,
          config?.afterpayEnabled,
          config?.klarnaInstallments,
          config?.afterpayInstallments
        )
      }

      if (this.myWidget) {
        delete this.myWidget
      }

      if (this.selectedProduct.klarna?.enabled || this.selectedProduct.afterPay?.enabled) {
        roxConfig.paymentInstallment = this.mapPaymentInstallments(
          this.selectedProduct.klarna?.enabled,
          this.selectedProduct.afterPay?.enabled,
          payOverTime?.klarna?.installments,
          this.selectedProduct.afterPay?.instalments
        )
      }

      const earlyAccessModule = RoxLensPanel.getEarlyAccessModule()
      const isInvitationTooltipConfigured = earlyAccessModule.isInvitationTooltipConfigured()
      if (!earlyAccessModule.isEligible() && isInvitationTooltipConfigured) {
        roxConfig.earlyAccessModule = earlyAccessModule
      } else {
        roxConfig.earlyAccessModule = undefined
      }
      if (roxLensPanel.autoDiscountBadge) {
        roxConfig.data.autoDiscountBadge = roxLensPanel.autoDiscountBadge
      }

      const isPrescriptionInputEnabled = roxLensPanel.isPrescriptionModuleEnabled

      if (isPrescriptionInputEnabled) {
        const prescriptionModule = RoxLensPanel.getPrescriptionModule()
        roxConfig.prescriptionModule = prescriptionModule
      } else {
        roxConfig.prescriptionModule = undefined
      }

      const virtualMirrorIsEnabled = this.isVMMVEnabled(this.selectedProduct.type)

      if (virtualMirrorIsEnabled) {
        await VirtualMirror.injectVirtualMirrorScript({
          vuexStore: this.$store,
        })
        const vmmvModule = RoxLensPanel.getVirtualMirrorModule()
        roxConfig.vmmvModule = vmmvModule
      } else {
        roxConfig.vmmvModule = undefined
      }

      roxConfig.layoutSettings = {
        enableSendItLater: sendItLaterPrescriptionIsEnabled,
      }

      if (!this.areRxcScriptsLoaded) {
        await this.$store.dispatch('pdp/' + ACTION_SET_RXC_SCRIPTS_STATUS, true)

        const sanitizeSrc = roxLensPanel.translations.replace('{locale}', this.sanitizedLocale)
        const translations = {
          src: sanitizeSrc,
        }

        console.log('ROX LENS PANEL RXC', roxLensPanel.rxc)

        Resources.loadResourcesWithCallback({
          resources: [translations, roxLensPanel.rxc],
          callback: () => {
            this.scriptsWereLoaded = true
          },
        })
      }
    },

    async getLensesAndFrames(roxFrameCatEntryId) {
      const data = await this.fetchLensesAndFrames(roxFrameCatEntryId)
      this.offerPrice = data.prices[0].frame.offerPrice
      this.listPrice = data.prices[0].frame.listPrice
      roxConfig.lensesData = { ...data }
    },
    async fetchLensesAndFrames(catEntryId) {
      if (this.packageIsStored(catEntryId)) {
        return this.getLensPackage(catEntryId)
      }
      const data = await this.fetchLensesAndFramesFromServer(catEntryId)
      await this.storeRxcLens({ catEntryId, lens: data })
      return data
    },
    getLensPackage(catEntryId) {
      const data = this.getSavedLensPackages(catEntryId)
      const clonedPackages = data.prices.map((pack) => ({
        frame: { ...pack.frame },
        lensPackage: { ...pack.lensPackage },
      }))
      return {
        ...data,
        prices: [...clonedPackages],
      }
    },
    async fetchLensesAndFramesFromServer(roxFrameCatEntryId) {
      const endPoint = wcs.getEndPoint('roxEyeLenses')
      const parameterizedEndpoint = endPoint.replace('FRAME_CATENTRY_ID', roxFrameCatEntryId)

      const params = {}

      if (wcs.isInPdp() && this.selectedProduct?.isSupernova) {
        const productPartNumbers = this.carousel
          ?.map((item) => item.productPartNumber)
          .filter((partNumber) => partNumber)
        if (productPartNumbers.length) {
          params.productPartNumbers = productPartNumbers?.join(',')
        }
      }

      const data = await axios.get(parameterizedEndpoint, { params }).then(({ data }) => data)
      return data
    },

    async changeConfigData() {
      roxConfig.data.frame = {
        catEntryId: this.selectedProduct.catEntryId,
        roxFrameCatentryId: this.selectedProduct.roxFrameCatEntryId,
        name: this.selectedProduct.modelName,
        upc: this.selectedProduct.partNumber,
        listPrice: this.listPrice,
        offerPrice: this.offerPrice,
        category: this.getProductCategory(),
        brand: RAY_BAN,
        imageUrl: this.getProductImage(this.selectedProduct.imageUrl),
        rxValues: this.selectedProduct.prescriptionThresholds,
        size: this.productSize,
        model: this.selectedProduct.productFrameModel,
        color: this.selectedProduct.productFrameColor,
        bridgeAndNosepads: {
          description: this.selectedProduct.geofits[0].label,
          tooltip: this.getBridgeDescription(this.selectedProduct),
        },
      }

      roxConfig.data.lens = {
        colorCategory: this.selectedRoxOpticLens
          ? this.selectedRoxOpticLens.colorCategory
          : this.selectedProduct.features?.lenses?.colorCategory,
        clen: this.selectedRoxOpticLens
          ? this.selectedRoxOpticLens.clen
          : this.selectedProduct.clen,
      }

      if (
        wcs.isInPdp() &&
        this.selectedProduct?.isSupernova &&
        roxLensPanel.isMixAndMatchButtonLabelVisible
      ) {
        await this.bulkLoadAllCarouselProducts()
        this.addFramesToRoxConfig()
      }
    },

    async bulkLoadAllCarouselProducts() {
      const selectedSize = this.selectedProduct.sizes.find(
        (item) => item.catEntryId === this.selectedProduct.catEntryId
      )?.size

      const catEntryIdsToSend = this.carousel
        .map((item) => item.variants.find((variant) => variant.size === selectedSize)?.catEntryId)
        .filter((item) => item)

      const allPromises = catEntryIdsToSend.map((catEntryId) => {
        const promise = new Promise((resolve, reject) => {
          this.fetchAndAddCorrelatedProduct(catEntryId).then(resolve).catch(reject)
        })

        return promise
      })

      await Promise.all(allPromises)
    },

    addFramesToRoxConfig() {
      const selectedSize = this.selectedProduct.sizes.find(
        (item) => item.catEntryId === this.selectedProduct.catEntryId
      )?.size
      const framesInformations = this.carousel
        ?.filter((item) => item.variants.find((variant) => variant.size === selectedSize))
        .map((item) => {
          const catEntryId = item.variants.find(
            (variant) => variant.size === selectedSize
          )?.catEntryId

          const correlatedProduct = get(this.correlatedProducts, catEntryId)
          // const listPrice = correlatedProduct.prices?.listPrice

          // const offerPrice =
          //   isEmpty(correlatedProduct.promotions) ||
          //   isNil(correlatedProduct.promotions)
          //     ? ''
          //     : WcsPromotions.calculatePromotionInProgress(item.promotions)

          const frame = {
            brand: RAY_BAN,
            catEntryId: correlatedProduct.catEntryId,
            category: item.hasColoredLenses ? SUNGLASSES : EYEGLASSES,
            color: correlatedProduct.productFrameColor,
            imageUrl: this.getProductImage(correlatedProduct.imageUrl),
            listPrice: this.listPrice,
            offerPrice: this.offerPrice,
            model: correlatedProduct.productFrameModel,
            name: correlatedProduct.modelName,
            roxFrameCatentryId: correlatedProduct.roxFrameCatEntryId,
            rxValues: correlatedProduct.prescriptionThresholds,
            size: this.getCorrelatedProductSize(
              correlatedProduct.catEntryId,
              correlatedProduct.sizes
            ),
            upc: correlatedProduct.partNumber,
            bridgeAndNosepads: {
              description: this.selectedProduct.geofits[0].label,
              tooltip: this.getBridgeDescription(correlatedProduct),
            },
          }

          return frame
        })

      roxConfig.data.frames = [...framesInformations]
    },

    getCorrelatedProductSize(catEntryId, sizes) {
      return sizes?.find((size) => size.catEntryId === catEntryId)?.size ?? ''
    },

    handleEyemedActions() {
      roxConfig.insuranceModule.openInsurancePanel = () => {
        if (this.isMobile()) {
          const mainApp = document.querySelector('.rb-app__main')
          mainApp.style.position = 'unset'
        }
        this.updateEyemedState({ fromRoxPanel: true })
        this.openEyemed()
      }

      roxConfig.insuranceModule.isLogged = () => {
        return this.isEyeMedEnabled && this.isEyeMedApplied
      }

      roxConfig.insuranceModule.isEnabled = () => {
        return this.isEyeMedEnabled && this.isEyeMedApplied
      }

      roxConfig.insuranceModule.removeInsuranceBenefits = () => {
        this.removeBenefits()
        this.updateEyemedState({ applied: false })
        Cookies.remove(EYEMED_LOGIN)
        window.dispatchEvent(
          new CustomEvent(roxConfig.insuranceModule.getEvents().INSURANCE_DISABLED)
        )
      }
      roxConfig.updateBenefits = this.updateBenefits
      roxConfig.insuranceModule.getInsuranceDiscounts = this.getInsuranceDiscounts
    },

    async getInsuranceDiscounts(_selectedFrame, _selectedPackages) {
      return RoxLensPanel.mapInsuranceDiscounts(
        _selectedPackages,
        roxConfig?.data?.frame?.roxFrameCatentryId,
        this.updateBenefits
      )
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    getProductImage(imageUrl) {
      return Images.getLensPanelImage(this.$mq, imageUrl)
    },
    getBridgeDescription(product) {
      if (!product.geofits || product.geofits.length === 0) {
        return undefined
      }
      const bridgeType = product.geofits[0].key
      let translationKey

      switch (bridgeType) {
        case LOW_BRIDGE_FIT:
          translationKey = 'common.low_bridge_description'
          break
        case HIGH_BRIDGE_FIT:
          translationKey = 'common.high_bridge_description'
          break
        default:
          return undefined
      }
      return this.$t(translationKey)
    },
    getProductCategory() {
      if (this.isProductStella) {
        const found =
          this.carousel &&
          this.carousel.find((color) =>
            color?.correlatedCatEntryIds?.includes(this.selectedProduct.catEntryId)
          )
        const containsColouredLens = !!found?.hasColoredLenses
        return containsColouredLens ? SUNGLASSES : EYEGLASSES
      } else {
        return this.selectedProduct.type === SUN ? SUNGLASSES : EYEGLASSES
      }
    },
    mapPaymentInstallments(
      klarnaEnabled = false,
      afterpayEnabled,
      klarnaInstallments,
      afterpayInstallments
    ) {
      if (klarnaEnabled && afterpayEnabled === Y) {
        return this.mapKlarnaAndAfterpayInstallments(klarnaInstallments, afterpayInstallments)
      } else if (klarnaEnabled) {
        return this.mapSingleInstallment(KLARNA, klarnaInstallments)
      } else if (afterpayEnabled === Y) {
        return this.mapSingleInstallment(AFTERPAY, afterpayInstallments)
      }
    },
    mapKlarnaAndAfterpayInstallments(klarnaInstallments, afterpayInstallments) {
      const installments = maxBy([klarnaInstallments, afterpayInstallments])
      return {
        types: [KLARNA, AFTERPAY],
        multiplePaymentInstallment: true,
        installments,
      }
    },
    mapSingleInstallment(type, installments) {
      return {
        type,
        installments,
      }
    },
    packageIsStored(catEntryId) {
      return !!this.rxcLenses[catEntryId]
    },
    getSavedLensPackages(catEntryId) {
      return this.rxcLenses[catEntryId]
    },
    isVMMVEnabled(type) {
      return (
        (type === OPTICAL && roxLensPanel.isVMMVEnabledInRoxPanelForClear) ||
        (type === SUN && roxLensPanel.isVMMVEnabledInRoxPanelForSun) ||
        (type === ELECTRONICS && roxLensPanel.isVMMVEnabledInRoxPanelForElectronics)
      )
    },
    async renderRXCPanel() {
      this.myWidget = window.RXC?.rxcWidget?.new(roxConfig)
      await this.myWidget?.render()
      this.hideSkeleton()
    },
    handleRXCLoaded() {
      this.isRoxLoaded = true
      if (FrameAdvisor.isInFrameAdvisorPage() && !this.isLensesCallDone) {
        return
      }
      this.renderRXCPanel()
    },
    getFlowName(product) {
      let selectFlowName
      switch (product.type) {
        case SUN:
          selectFlowName = roxLensPanel.flowNameSunglasses
          break
        case OPTICAL:
          selectFlowName = roxLensPanel.flowNameEyeglasses
          break
        case ELECTRONICS:
          selectFlowName = roxLensPanel.flowNameElectronics
          break
        default:
          selectFlowName = ''
      }
      return selectFlowName
    },
    hideSkeleton() {
      this.$refs.skeleton.hideOverlay()
    },
  },
}
